import { createReducer, createActions } from 'reduxsauce';
import { currentToVenueDate } from 'utils/date';

/* ------------------- Types and Action Creators -------------- */
const { Types, Creators } = createActions({
  reset: [],
  loadPromotions: ['silent', 'venueId'],
  setPromotions: ['promotions'],
  setPromotionsLoading: ['loading'],
});

export const PromotionTypes = Types;

export default Creators;

/* ---------------- Selectors -------------- */
export const PromotionSelectors = {
  selectPromotions: (state) => state.promotion.promotions,
  selectPromotionsLoading: (state) => state.promotion.promotionsLoading,
  selectPromotionVenues: (state) => {
    return state.app.venues.filter((v) => {
      console.log('>>>>>>>>>>>> venues', v);
      return state.promotion.promotions.find((p) => p.venueId === v.id);
    });
  },
  selectPromotionsByVenue: (venueId) => (state) => {
    return state.promotion.promotions.filter((p) => p.venueId === venueId);
  },
  selectAvailablePromotionsByVenue: (venueId) => (state) => {
    // @TODO move over to utils
    return state.promotion.promotions.filter((p) => {
      if (p.venue !== venueId) {
        return false;
      }

      const venueDetail = state.app.venues.find((v) => v.id === venueId);
      const day = currentToVenueDate(
        new Date(),
        venueDetail.settings.hours.endOfNight
      )
        .format('ddd')
        .toLowerCase();

      return p.allowedWeekdays[day];
    });
  },
};

/* ---------------- Initial State -------------- */
export const INITIAL_STATE = {
  promotions: [],
  promotionsLoading: false,
};

/* ---------------- Reducers -------------- */
export const setPromotions = (state, { promotions }) => ({
  ...state,
  promotions,
});

export const setPromotionsLoading = (state, { loading }) => ({
  ...state,
  promotionsLoading: loading,
});
export const reset = () => ({ ...INITIAL_STATE });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_PROMOTIONS]: setPromotions,
  [Types.SET_PROMOTIONS_LOADING]: setPromotionsLoading,
  [Types.RESET]: reset,
});
